import { Tag, Pencil, Trash2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../ui/dialog";
import { Switch } from "../ui/switch";
import { inputCls } from "./adminConstants";

export function DiscountsView({ ctx }) {
  const {
    discounts, openEditDiscount, removeDiscount,
    discountDialogOpen, setDiscountDialogOpen, discountForm, setDiscountForm,
    saveDiscount, savingDiscount, editingDiscount,
  } = ctx;

  return (
    <div className="p-6 lg:p-12" data-testid="discounts-view">
      {discounts.length === 0 ? (
        <div className="border border-white/15 py-24 text-center font-mono-accent text-xs uppercase tracking-widest text-[#E8E2D2]/40">
          Nessun codice sconto — crea il primo con "Nuovo codice"
        </div>
      ) : (
        <div className="border border-white/20 overflow-x-auto">
          <table className="w-full text-left" data-testid="discounts-table">
            <thead>
              <tr className="border-b border-white/20 font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/40">
                <th className="px-4 py-4">Codice</th>
                <th className="px-4 py-4">Sconto</th>
                <th className="px-4 py-4 hidden md:table-cell">Min. ordine</th>
                <th className="px-4 py-4 hidden md:table-cell">Scadenza</th>
                <th className="px-4 py-4 hidden md:table-cell">Usi</th>
                <th className="px-4 py-4">Stato</th>
                <th className="px-4 py-4 text-right">Azioni</th>
              </tr>
            </thead>
            <tbody>
              {discounts.map((d) => (
                <tr key={d.id} className="border-b border-white/10" data-testid={`discount-row-${d.id}`}>
                  <td className="px-4 py-3 font-mono-accent text-sm text-[#D47738] flex items-center gap-2">
                    <Tag className="w-3.5 h-3.5" /> {d.code}
                  </td>
                  <td className="px-4 py-3 font-serif-display text-xl">
                    {d.type === "percent" ? `${d.value}%` : `€ ${Number(d.value).toFixed(2)}`}
                  </td>
                  <td className="px-4 py-3 hidden md:table-cell font-mono-accent text-xs text-[#E8E2D2]/60">
                    {d.min_subtotal > 0 ? `€ ${Number(d.min_subtotal).toFixed(2)}` : "—"}
                  </td>
                  <td className="px-4 py-3 hidden md:table-cell font-mono-accent text-xs text-[#E8E2D2]/60">
                    {d.expires_at || "—"}
                  </td>
                  <td className="px-4 py-3 hidden md:table-cell font-mono-accent text-xs text-[#E8E2D2]/60">
                    {d.used_count || 0}{d.max_uses > 0 ? ` / ${d.max_uses}` : ""}
                  </td>
                  <td className="px-4 py-3">
                    <span className={`font-mono-accent text-[9px] uppercase tracking-widest px-2 py-1 border ${d.active ? "bg-[#4A6E4A] text-[#E8E2D2] border-[#4A6E4A]" : "border-white/20 text-[#E8E2D2]/40"}`}>
                      {d.active ? "Attivo" : "Disattivo"}
                    </span>
                  </td>
                  <td className="px-4 py-3">
                    <div className="flex items-center justify-end gap-2">
                      <button onClick={() => openEditDiscount(d)} className="p-2 border border-white/20 hover:border-[#D47738] hover:text-[#D47738] transition-colors" data-testid={`edit-discount-${d.id}`}>
                        <Pencil className="w-3.5 h-3.5" />
                      </button>
                      <button onClick={() => removeDiscount(d)} className="p-2 border border-white/20 hover:border-[#9E3C3C] hover:text-[#9E3C3C] transition-colors" data-testid={`delete-discount-${d.id}`}>
                        <Trash2 className="w-3.5 h-3.5" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <Dialog open={discountDialogOpen} onOpenChange={setDiscountDialogOpen}>
        <DialogContent className="bg-[#141A14] border border-white/20 text-[#E8E2D2] max-w-md" data-testid="discount-dialog">
          <DialogHeader>
            <DialogTitle className="font-serif-display text-3xl text-[#E8E2D2]">
              {editingDiscount ? "Modifica Codice" : "Nuovo Codice Sconto"}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-3 py-2">
            <div>
              <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Codice</label>
              <input value={discountForm.code} onChange={(e) => setDiscountForm({ ...discountForm, code: e.target.value.toUpperCase() })}
                placeholder="ES. BENVENUTO10" className={inputCls + " mt-1 uppercase"} data-testid="discount-code-input" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Tipo</label>
                <select value={discountForm.type} onChange={(e) => setDiscountForm({ ...discountForm, type: e.target.value })}
                  className={inputCls + " mt-1 cursor-pointer"} data-testid="discount-type-select">
                  <option value="percent" className="bg-[#0D110D]">Percentuale (%)</option>
                  <option value="fixed" className="bg-[#0D110D]">Importo fisso (€)</option>
                </select>
              </div>
              <div>
                <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">
                  Valore {discountForm.type === "percent" ? "(%)" : "(€)"}
                </label>
                <input type="number" step="any" value={discountForm.value} onChange={(e) => setDiscountForm({ ...discountForm, value: e.target.value })}
                  className={inputCls + " mt-1"} data-testid="discount-value-input" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Ordine minimo € (0 = nessuno)</label>
                <input type="number" step="any" value={discountForm.min_subtotal} onChange={(e) => setDiscountForm({ ...discountForm, min_subtotal: e.target.value })}
                  className={inputCls + " mt-1"} data-testid="discount-min-input" />
              </div>
              <div>
                <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Limite usi (0 = illimitato)</label>
                <input type="number" value={discountForm.max_uses} onChange={(e) => setDiscountForm({ ...discountForm, max_uses: e.target.value })}
                  className={inputCls + " mt-1"} data-testid="discount-maxuses-input" />
              </div>
            </div>
            <div>
              <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Scadenza (opzionale)</label>
              <input type="date" value={discountForm.expires_at || ""} onChange={(e) => setDiscountForm({ ...discountForm, expires_at: e.target.value })}
                className={inputCls + " mt-1"} data-testid="discount-expires-input" />
            </div>
            <label className="flex items-center justify-between border border-white/15 px-4 py-3">
              <span className="font-mono-accent text-[11px] uppercase tracking-widest text-[#E8E2D2]/80">Attivo</span>
              <Switch checked={!!discountForm.active} onCheckedChange={(v) => setDiscountForm({ ...discountForm, active: v })}
                className="data-[state=checked]:bg-[#D47738]" data-testid="discount-active-switch" />
            </label>
          </div>
          <DialogFooter>
            <button onClick={() => setDiscountDialogOpen(false)} className="px-6 py-3 border border-white/20 font-mono-accent text-xs uppercase tracking-widest hover:border-white/50 transition-colors">
              Annulla
            </button>
            <button onClick={saveDiscount} disabled={savingDiscount} className="px-6 py-3 bg-[#D47738] text-[#0D110D] font-mono-accent text-xs uppercase tracking-widest hover:bg-[#E8E2D2] transition-colors disabled:opacity-50" data-testid="save-discount-btn">
              {savingDiscount ? "Salvataggio..." : "Salva"}
            </button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
